import { getRouteApi } from '@tanstack/react-router';
import type { APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMAND } from 'cpool-constants';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { canExecuteForAttribution } from '~/features/leadDetails/utils/aclPermissions';

type Props = {
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
    commandName: LOAN_REQUEST_COMMAND;
};

export const useIsLoanFormDisabled = ({ applicant, commandName }: Props) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });

    return !canExecuteForAttribution({ attribution: applicant, commandName, permissions });
};
